import { Component } from "react";
import { toast } from "react-toastify";

import { JobStatus } from "@app/jobs";
import { Message, MessageType, NotificationContextProps, withNotificationContext } from "@app/notifications";
import { ClientGapResultsAvailableNotificationMessagePayload } from "@app/notifications/message";

class NotificationHandler extends Component<NotificationContextProps> {

  public async componentDidMount() {
    this.props.subscribe(this.handleNotifications);
  }

  public componentWillUnmount() {
    this.props.unsubscribe(this.handleNotifications);
  }

  public render() {
    return this.props.children;
  }

  private handleNotifications = async (message: Message) => {
    if (message) {
      switch (message.notificationType as MessageType) {
        case MessageType.ClientGapLinkResultsAvailable:
          const clientGapResultsAvailablePayload = message.payload as ClientGapResultsAvailableNotificationMessagePayload;
          const toastOptions = { containerId: "z-index-9999" };

          switch (clientGapResultsAvailablePayload.jobStatus) {
            case JobStatus.Failed:
              toast(<span>Job failure. Client gap results were not refreshed.</span>, toastOptions);
              break;
            case JobStatus.Finished:
              toast(<span>Client gap results successfully refreshed.</span>, toastOptions);
              break;
          }
          break;
        case MessageType.ReportComplete:
          //TODO: Notify when report is complete
      }
    }
  }

}

export default withNotificationContext<NotificationContextProps>(NotificationHandler);
